import { useContext, useEffect } from 'react'
import { NavContext } from '../../context/global_context'
import ErrorCard from '../../components/common/ErrorCard'
import { useIntl } from 'react-intl'
import { QuestionCircleOutlined } from '@ant-design/icons'

const NotFound = () => {
  const intl = useIntl()
  const [state, dispatch] = useContext(NavContext)
  useEffect(() => {
    dispatch({ type: 'header', data: { show_back_btn: false } })
  }, [])
  return (
    <div className="page not-found-404">
      <ErrorCard
        icon={QuestionCircleOutlined} 
        iconStyle={{ color: 'var(--color-warning-icon, #faad14)' }}
        title={intl.formatMessage({ id: 'notFound.title' })} 
        sub_title={intl.formatMessage({ id: 'notFound.subtitle' })} />
    </div>
  )
}

export default NotFound
